<div class="affmensu-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a [routerLink]="['/utilisateur/espace/busnes/activite', safeName, accountNumber]" class="crumb-link">
        <i class="bi bi-arrow-left"></i> Retour activite business
      </a>
      <span class="crumb-current">Rapport mensuel</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Compte pro</p>
        <h1>{{bDescription}}</h1>
        <p class="lead">Synthèse des opérations par mois pour {{accountNumber}}.</p>
      </div>
      <div class="pill-row d-none d-sm-flex">
        <span class="pill pill-strong">Mensuel</span>
        <span class="pill">Achats / Dépôts / Retraits / Transferts</span>
      </div>
    </div>
  </div>

  <div class="card-glass p-3 mb-3">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h4 class="mb-0">Rapport du mois en cours</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="text-muted mb-0" for="monthSelectMensu">Mois</label>
        <select id="monthSelectMensu"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-0">Affichage par défaut limité au mois en cours. Sélectionnez un mois passé pour revoir un rapport déjà chargé.</p>-->
  </div>

  <div class="row g-3">
    <div class="col-xl-6 col-lg-6 col-md-12" *ngFor="let m of mensuellist">
      <div class="card card-glass border-0 h-100">
        <div class="card-header generalbgColorV2 text-white text-center font-weight-bolder">
          {{m.month}}/{{m.annee}}
        </div>
        <div class="card-body">
          <div class="metric-row">
            <span>Total achats</span>
            <strong>{{m.achat | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Achats en ligne</span>
            <strong>{{m.achatEnLigne | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Dépôt initial</span>
            <strong>{{m.depot | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Dépôt clients</span>
            <strong>{{m.depotClient | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Retrait principal</span>
            <strong>{{m.retrait | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Retrait client</span>
            <strong>{{m.retraiclient | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Bénéfice dépôt</span>
            <strong>{{m.bDepot | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row">
            <span>Bénéfice retrait</span>
            <strong>{{m.bRetrait | currency:m.sigleMonnaie}}</strong>
          </div>
          <!--<div class="metric-row highlight">
            <span>Solde total</span>
            <strong>{{(m.depot- m.depotClient )+(m.retraiclient+(m.achat-m.retrait) +
              m.bDepot+m.bRetrait+m.achatEnLigne) | currency:m.sigleMonnaie}}</strong>
          </div>-->
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="!mensuellist || mensuellist.length === 0">
      <div class="card card-glass p-3 text-center text-muted">
        Aucun rapport mensuel disponible.
      </div>
    </div>
  </div>
</div>
